import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { FeldBeschreibung } from '../../domain/model/feldbeschreibung.model';
import { map, shareReplay } from 'rxjs/operators';
import { Feld } from '../../domain/model/feld.enum';

@Injectable({
    providedIn: 'root',
})
export class FeldBeschreibungService {

    private cache$: Observable<Map<string, FeldBeschreibung>>;
    private CACHE_CALLED: number;
    private CACHE_SIZE = 1;

    private http = inject(HttpClient);

    public listFeldBeschreibung(): Observable<FeldBeschreibung[]> {
        return this.http.get<FeldBeschreibung[]>(environment.API_URL + '/feldbeschreibung');
    }

    public listFeldBeschreibungAsMap(): Observable<Map<string, FeldBeschreibung>> {
        return this.listFeldBeschreibung().pipe(
            map((value) => value.reduce((previousValue, currentValue) => {
                previousValue[currentValue.id] = currentValue;
                return previousValue;
            }, new Map<string, FeldBeschreibung>())),
        );
    }

    public getCachedFeldBeschreibung(feld: Feld): Observable<FeldBeschreibung | null> {
        if (!this.cache$) {
            this.CACHE_CALLED = Date.now();
            this.cache$ = this.listFeldBeschreibungAsMap().pipe(
                shareReplay(this.CACHE_SIZE),
            );
        }

        return this.cache$.pipe(
            map(value => value[feld]),
        );
    }

    public invalidateCache(): void {
        this.cache$ = null;
    }

    public getFeldBeschreibung(id: string): Observable<FeldBeschreibung> {
        return this.http.get<FeldBeschreibung>(environment.API_URL + '/feldbeschreibung/' + id);
    }

    public updateFeldBeschreibung(beschreibung: FeldBeschreibung): Observable<FeldBeschreibung> {
        return this.http.put<FeldBeschreibung>(environment.API_URL + '/admin/feldbeschreibung/' + beschreibung.id, beschreibung);
    }
}
